<h1 *ngIf="!isAppMobile" tabindex="-1" class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">{{ titre | translate }}</h1>
<h2 *ngIf="!isAppMobile" tabindex="-1" class="dsd-t-3">{{ 'caad.modifier-fiserv.titre' | translate }}</h2>
<div *ngIf="coordonneesCredit">
  <dsd-form [formGroup]="formFiserv">
    <span class="dsd-form-required">{{ 'caad.modifier.coordonnees.ajoutedechamps' | translate }}</span>
    <dsd-container>
      <h3 class="dsd-t-4 dsd-mb-md">{{ 'caad.modifier-fiserv.coordonnees.titre' | translate }}</h3>
      <app-modification-adresse
        [formGroup]="formFiserv"
        [isBancaire]="false"
        [adresseCourante]="adresseCourante"></app-modification-adresse>
      <div class="dsd-hr"></div>
      <h3 class="dsd-t-4 dsd-mb-md">{{ 'caad.modifier-fiserv.telephone.titre' | translate }}</h3>
      <app-modification-telephone-credit [formGroup]="formFiserv"></app-modification-telephone-credit>
      <div class="dsd-hr"></div>
      <h3 class="dsd-t-4 dsd-mb-md">{{ 'caad.modifier-fiserv.courriel.titre' | translate }}</h3>
      <app-avertissement-modification-plusieurs-courriels-credit
        *ngIf="!doitAfficherUneAdresseCourriel"
        [reponseCoordonneesCredit]="coordonneesCredit"></app-avertissement-modification-plusieurs-courriels-credit>
      <app-modification-courriel
        [formGroup]="formFiserv"
        [required]="true"
        [maxLength]="50"></app-modification-courriel>
    </dsd-container>
    <div class="zone-btn">
      <dsd-button variant="primary" full-width="xs" type="submit" (dsdButtonClick)="naviguerVersPageValidation()">{{
        'caad.button.valider' | translate
      }}</dsd-button>
      <dsd-button full-width="xs" (dsdButtonClick)="annulerModification()">{{
        'caad.button.annuler' | translate
      }}</dsd-button>
    </div>
  </dsd-form>
</div>
<div class="dsd-mt-md">
  <app-bloc-contact-fiserv></app-bloc-contact-fiserv>
</div>
